import { render, staticRenderFns } from "./ProductCategoryCrud.vue?vue&type=template&id=647dbc01&"
import script from "./ProductCategoryCrud.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports